import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center pt-3 pb-3"
}
const _hoisted_2 = {
  key: 1,
  class: "pt-4 pb-3"
}
const _hoisted_3 = { class: "modal-tittle d-flex justify-content-around" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "USERNAME", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "LASTNAME", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "PHONE-NUMBER", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "EMAIL", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_17 = { class: "w-50" }
const _hoisted_18 = { class: "w-50" }
const _hoisted_19 = { class: "d-flex justify-content-between gap-4 mt-4" }
const _hoisted_20 = { class: "w-100 bg-white p-3 rounded-4" }
const _hoisted_21 = { class: "d-flex justify-content-between gap-4 mt-4" }
const _hoisted_22 = { class: "w-50 bg-white p-3 rounded-4" }
const _hoisted_23 = { class: "w-50 bg-white p-3 rounded-4" }
const _hoisted_24 = { class: "d-flex justify-content-between gap-4 mt-4" }
const _hoisted_25 = { class: "w-50 bg-white p-3 rounded-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-floppy-o",
  "aria-hidden": "true"
}, null, -1)

import axios from "axios";
import { ref, toRefs } from "vue";
import AverageFixInterestRates from "./Property/AverageFixInterestRates.vue";
import MinimumDownPayment from "./Property/MinimumDownPayment.vue";
import MortageInsurance from "./Property/MortageInsurance.vue";
import BackEndRatio from "./Property/BackEndRatio.vue";
import MinumunDownPaymentAvoidPayment from "./Property/MinumunDownPaymentAvoidPayment.vue";
import FamilyHousingExpenses from "./Property/FamilyHousingExpenses.vue";
import MaximumLoanAmount from "./Property/MaximumLoanAmount.vue";
import UnderwritingCommission from "./Property/UnderwritingCommission.vue";

import { useToast } from "@/composables/useToast";
import { environment } from "@/environment";
import { response } from "express";

//VARIABLES

export default /*#__PURE__*/_defineComponent({
  __name: 'MLOTables',
  props: {
    userID: Number,
    type: String,
    specialProgram: {
        dafault: false,
        type: Boolean,
    },
    realtorMLO: {
        default: false,
        type: Boolean
    }
},
  setup(__props) {

const props = __props;

const toast = useToast();

const url = environment.URL_API;
const loading = ref(false);



const { userID, type, specialProgram, realtorMLO } = toRefs(props);

const specialProgramName = ref({
    ID: null,
    user_id: userID.value,
    name: "",
});

const realtorMLOData = ref({
    ID: null,
    user_id: userID.value,
    name: '',
    lastname: '',
    phone: '',
    email: '',
})

const defaultAverageFixInterestRate = {
    ID: null,
    user_id: userID.value,
    type: type.value,
    years: 0,
    fha_score: "0-0",
    fha_percent: 0,
    conventional_score: "0-0",
    conventional_percent: 0,
    va_score: "0-0",
    va_percent: 0,
};

const defaultMinimumDownPayment = {
    ID: null,
    user_id: userID.value,
    type: type.value,
    years: 0,
    fha_score: "0-0",
    fha_percent: 0,
    conventional_score: "0-0",
    conventional_percent: 0,
    va_score: "0-0",
    va_percent: 0,
};

const data15yearsAverage = ref([]);
const data30yearsAverage = ref([]);
const dataMinimumDownPayment = ref([]);

const add15YearsAverage = () => {
    const pushElement = { ...defaultAverageFixInterestRate };
    pushElement.years = 15;
    data15yearsAverage.value.push(pushElement);
};

const add30yearsAverage = () => {
    const pushElement = { ...defaultAverageFixInterestRate };
    pushElement.years = 30;
    data30yearsAverage.value.push(pushElement);
};

const addMinimumDownPayment = () => {
    const pushElement = { ...defaultMinimumDownPayment };
   
    dataMinimumDownPayment.value.push(pushElement);
};


const dataMortgageInsurance = ref({
    ID: null,
    user_id: userID.value,
    type: type.value,
    fha: 0,
    conventional: 0,
    va: 0,
    comments: "",
});

const dataUnderwritingCommission = ref({
    ID: null,
    user_id: userID.value,
    type: type.value,
    mlo_commission: 0,
})

const dataBackEndRatio = ref({
    ID: null,
    user_id: userID.value,
    type: type.value,
    fha: 0,
    conventional: 0,
    va: 0,
});

const dataMinumunDownPaymentAvoidPayment = ref({
    ID: null,
    user_id: userID.value,
    type: type.value,
    fha: 0,
    conventional: 0,
    va: 0,
});

const defaultFamilyHousingExpense = {
    ID: null,
    user_id: userID.value,
    type: type.value,
    expense: "",
};
const dataFamilyHousingExpenses = ref([]);
const addFamilyHousingExpenses = () => {
    dataFamilyHousingExpenses.value.push({ ...defaultFamilyHousingExpense });
};
const removeFamilyHousingExpenses = async (index, ID) => {
    dataFamilyHousingExpenses.value.splice(index, 1);
    const response = await axios(
        `${url}tables/housingexpenses`,
        {
            method: "DELETE",
            data: { ID },
        }
    );
    
};

const dataMaximumLoanAmount = ref({
    ID: null,
    user_id: userID.value,
    type: type.value,
    fha: 0,
    conventional: 0,
    va: 0,
    comments: "",
});

const getData = async () => {
    loading.value = true;
    const response = await axios(
        `${url}tables?user_id=${userID.value}&type=${type.value}`,
        {
            method: "GET",
        }
    );

    if (!response.data.error) {
        data15yearsAverage.value = response.data.yearsAverage15
            ? response.data.yearsAverage15
            : [];
        data30yearsAverage.value = response.data.yearsAverage30
            ? response.data.yearsAverage30
            : [];
            dataMinimumDownPayment.value = response.data.minimumDownPayment
            ? response.data.minimumDownPayment
            : [];
        dataMortgageInsurance.value = response.data.mortgageInsurance
            ? response.data.mortgageInsurance
            : {
                ID: null,
                user_id: userID.value,
                type: type.value,
                fha: 0,
                conventional: 0,
                va: 0,
                comments: "",
            };
        dataUnderwritingCommission.value = response.data.underwritingCommission
            ? response.data.underwritingCommission
            : {
                ID: null,
                user_id: userID.value,
                type: type.value,
                mlo_commission: 0,
            };
        dataBackEndRatio.value = response.data.backEndRatio
            ? response.data.backEndRatio
            : {
                ID: null,
                user_id: userID.value,
                type: type.value,
                fha: 0,
                conventional: 0,
                va: 0,
                comments: "",
            };
        dataMinumunDownPaymentAvoidPayment.value = response.data
            .minumunDownPaymentAvoidPayment
            ? response.data.minumunDownPaymentAvoidPayment
            : {
                ID: null,
                user_id: userID.value,
                type: type.value,
                fha: 0,
                conventional: 0,
                va: 0,
                comments: "",
            };
        dataFamilyHousingExpenses.value = response.data.familyHousingExpenses
            ? response.data.familyHousingExpenses
            : [];
        dataMaximumLoanAmount.value = response.data.maximumLoanAmount
            ? response.data.maximumLoanAmount
            : {
                ID: null,
                user_id: userID.value,
                type: type.value,
                fha: 0,
                conventional: 0,
                va: 0,
                comments: "",
            };
        specialProgramName.value = response.data.specialProgramName
            ? response.data.specialProgramName
            : {
                ID: null,
                user_id: userID.value,
                name: "",
            };
        realtorMLOData.value = response.data.realtorMLOData
            ? response.data.realtorMLOData
            : {
                ID: null,
                user_id: userID.value,
                name: '',
                lastname: '',
                phone: '',
                email: '',
            }
        loading.value = false;
    }
};

const saveData = async () => {
    loading.value = true;
    const response = await axios(`${url}tables`, {
        method: "POST",
        data: {
            yearsAverage15: data15yearsAverage.value,
            yearsAverage30: data30yearsAverage.value,
            MinimumDownPayment: dataMinimumDownPayment.value,
            MortgageInsurance: dataMortgageInsurance.value,
            UnderwritingCommission: dataUnderwritingCommission.value,
            BackEndRatio: dataBackEndRatio.value,
            MinumunDownPaymentAvoidPayment:
            dataMinumunDownPaymentAvoidPayment.value,
            FamilyHousingExpenses: dataFamilyHousingExpenses.value,
            MaximumLoanAmount: dataMaximumLoanAmount.value,
            specialProgramName: specialProgramName.value,
            specialProgram: specialProgram.value,
            realtorMLO: realtorMLO.value,
            realtorMLOData: realtorMLOData.value,
        },
    });

    if (!response.data.error) {
        loading.value = false;
        await toast.success(response.data.message, {
            position: "top-end",
            timer: 3000,
            showCloseButton: true,
        });
        getData()
    } else {
        loading.value = false;
        await toast.error(response.data.message, {
            position: "top-end",
            timer: 3000,
            showCloseButton: true,
        });
    }
};

getData();

return (_ctx: any,_cache: any) => {
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Loader, { visible: loading.value }, null, 8, ["visible"]),
    (_unref(specialProgram))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives(_createElementVNode("input", {
            placeholder: "Enter Special Program Name",
            class: "input-tittle",
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((specialProgramName.value.name) = $event))
          }, null, 512), [
            [_vModelText, specialProgramName.value.name]
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(realtorMLO))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(),
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((realtorMLOData.value.name) = $event))
              }, null, 512), [
                [_vModelText, realtorMLOData.value.name]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createTextVNode(),
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((realtorMLOData.value.lastname) = $event))
              }, null, 512), [
                [_vModelText, realtorMLOData.value.lastname]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createTextVNode(),
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((realtorMLOData.value.phone) = $event))
              }, null, 512), [
                [_vModelText, realtorMLOData.value.phone]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createTextVNode(),
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((realtorMLOData.value.email) = $event))
              }, null, 512), [
                [_vModelText, realtorMLOData.value.email]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(AverageFixInterestRates, {
          subTitle: "Average Fix Interest Rates",
          title: "15 YEARS",
          tableData: data15yearsAverage.value,
          addFunction: add15YearsAverage
        }, null, 8, ["tableData"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(AverageFixInterestRates, {
          subTitle: "Average Fix Interest Rates",
          title: "30 YEARS",
          tableData: data30yearsAverage.value,
          addFunction: add30yearsAverage
        }, null, 8, ["tableData"])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createVNode(MinimumDownPayment, {
          subTitle: "Minimum Down Payment",
          title: "Avoid Payment Private Mortgage Insurance",
          tableData: dataMinimumDownPayment.value,
          addFunctionTwo: addMinimumDownPayment
        }, null, 8, ["tableData"])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createVNode(MortageInsurance, { data: dataMortgageInsurance.value }, null, 8, ["data"]),
        _createVNode(UnderwritingCommission, { data: dataUnderwritingCommission.value }, null, 8, ["data"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(MaximumLoanAmount, { data: dataMaximumLoanAmount.value }, null, 8, ["data"])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createVNode(BackEndRatio, { data: dataBackEndRatio.value }, null, 8, ["data"]),
        _createVNode(FamilyHousingExpenses, {
          data: dataFamilyHousingExpenses.value,
          addFunction: addFamilyHousingExpenses,
          removeFunction: removeFamilyHousingExpenses
        }, null, 8, ["data"])
      ])
    ]),
    _createElementVNode("div", { class: "d-flex justify-content-center" }, [
      _createElementVNode("button", {
        class: "btn btn-primary px-5 mt-3",
        onClick: saveData
      }, [
        _createTextVNode(" Save Data "),
        _hoisted_26
      ])
    ])
  ]))
}
}

})